import type { IconSvgObject } from './types';

const AssignmentsIcon: IconSvgObject = [
  ["path", { d: "M4 3H3C2.44772 3 2 3.44772 2 4V18.5L3.5 21L5 18.5V4C5 3.44772 4.55228 3 4 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 12V5C21 3.89543 20.1046 3 19 3H10C8.89543 3 8 3.89543 8 5V19C8 20.1046 8.89543 21 10 21H12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 7H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 11H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M14.5 18.5L16.5 21L22 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M2 7H5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "5" }]
];

export default AssignmentsIcon;
